import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { components as RSComponents } from "react-select";
import { FiSearch, FiUser } from "react-icons/fi";
import PeopleStore from "../../../stores/PeopleStore";
import "./PersonSearchInput.scss";

const styles = {
  container: provided => ({
    ...provided,
    width: "100%"
  }),
  control: provided => ({
    ...provided,
    border: "none",
    boxShadow: "var(--shadow)",
    borderRadius: 0
  }),
  placeholder: provided => ({
    ...provided,
    color: "var(--medium-gray)",
    opacity: 0.5
  }),
  loadingIndicator: provided => ({
    ...provided,
    color: "var(--dark-primary)"
  }),
  menu: provided => ({
    ...provided,
    borderRadius: 0
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: state.isSelected
        ? "var(--dark-primary)"
        : state.isFocused
          ? "var(--super-light-gray)"
          : "var(--white)",
      ...(state.isSelected ? { fontWeight: "700" } : {}),
      cursor: "pointer",
      ":active": {
        ...provided[":active"],
        backgroundColor: state.isSelected ? "var(--dark-primary)" : "var(--dark-primary-transparent)"
      }
    };
  }
};

const getNoOptionsMessage = ({ inputValue }) => {
  if (!inputValue) return "Type something to search";
  else return "No results found... try altering your search a bit.";
};

const getOptionsForSearch = async inputValue => {
  if (!inputValue) return [];
  return await PeopleStore?.search(inputValue);
};

const getOptionValue = o => o;

const getOptionLabel = o => `${o?.firstName} ${o?.lastName}`;

const ResultOption = props => {
  const {
    firstName,
    lastName,
    email,
    isParent,
    isStudent,
    isTeacher,
    infusionsoftId,
    userId: lpmId,
    profilePicture
  } = props?.value || {};
  const [profilePictureError, setProfilePictureError] = useState(false);
  const markProfilePictureError = () => setProfilePictureError(true);

  const teacherChip = isTeacher ? (
    <div className="chip teacher" key="t">
      Teacher
    </div>
  ) : null;
  const parentChip = isParent ? (
    <div className="chip parent" key="p">
      Parent
    </div>
  ) : null;
  const studentChip = isStudent ? (
    <div className="chip student" key="s">
      Student
    </div>
  ) : null;
  const chips = [teacherChip, parentChip, studentChip].filter(Boolean);
  return (
    <RSComponents.Option {...props}>
      <div className="search-result-wrapper">
        <div className="search-result-content">
          {!profilePictureError ? (
            <img
              className="profile-picture"
              src={profilePicture}
              alt={`${firstName} ${lastName} profile picture`}
              onError={markProfilePictureError}
            />
          ) : (
            <div className="profile-image">
              <FiUser color="var(--medium-gray)" size={40} />
            </div>
          )}
          <div className="info-container">
            <div className="search-result-name">
              {firstName?.toProperCase()} {lastName?.toProperCase()}
            </div>
            <div className="search-result-email">{email}</div>
            <div className="search-result-id">InfusionSoft ID: {infusionsoftId}</div>
            <div className="search-result-id">LPM ID: {lpmId}</div>
            <div className="person-type-chips-container">{chips}</div>
          </div>
        </div>
      </div>
    </RSComponents.Option>
  );
};

const DropdownIndicator = props => {
  return (
    <RSComponents.DropdownIndicator {...props}>
      <FiSearch color="var(--medium-gray)" size={24} />
    </RSComponents.DropdownIndicator>
  );
};

const PersonSearchInput = props => {
  const [search, setSearch] = useState("");
  const updateSearch = thing => setSearch(thing);

  const onChange = value => {
    if (typeof props?.onSelect === "function") props.onSelect(value);
  };

  return (
    <AsyncSelect
      {...props}
      styles={styles}
      placeholder="Search People"
      inputValue={search}
      value={props?.hasValue ? props?.value : null}
      onInputChange={updateSearch}
      onChange={onChange}
      isMulti={false}
      noOptionsMessage={getNoOptionsMessage}
      loadOptions={getOptionsForSearch}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      components={{ DropdownIndicator, IndicatorSeparator: () => null, Option: ResultOption }}
    />
  );
};

export default PersonSearchInput;
